import React, { useEffect, useState } from 'react';
import { TabContent, TabPane } from 'reactstrap';
import About from './AboutComponent';
import Compare from './CompareComponent';
import Exchange from './ExchangeComponent';
import Footer from './FooterComponent';
import Header from './HeaderComponent';
import Menu from './MenuComponent';

function Main(props) {
    const [activeTab, setActiveTab] = useState('1');
    const [CRYPTO, setCRYPTO] = useState(null);
    const toggle = tab => {
        if (activeTab !== tab) setActiveTab(tab);
    }

    useEffect(() => {
        fetch('https://api.coingecko.com/api/v3/coins/markets?vs_currency=usd&order=market_cap_desc&per_page=250&page=1')
            .then(res => res.json())
            .then((prices) => {
                // console.log("coingecko prices response : ", prices);
                let v = [];
                const defaultExchanges = ['Coinbase', 'Binance', 'Kraken', 'Bitstamp', 'Bitfinex'];
                prices.forEach((val) => {
                    v.push({
                        id: val.symbol.toLowerCase() + 'usd',
                        pair: val.symbol.toLowerCase() + 'usd',
                        market: defaultExchanges,
                        info: val
                    });
                });
                // console.log('Content : ', v);
                setCRYPTO(v);

            }, (err) => console.log(err))
    }, []);

    return (
        <div>
            <Header activeTab={activeTab} toggle={toggle} />
            <TabContent activeTab={activeTab} >
                <TabPane tabId="1"><Menu CRYPTO={CRYPTO} /></TabPane>
                <TabPane tabId="2"><Compare CRYPTO={CRYPTO} /></TabPane>
                <TabPane tabId="3"><Exchange CRYPTO={CRYPTO} /></TabPane>
                <TabPane tabId="4"><About /></TabPane>
            </TabContent>
            <Footer toggle={toggle}/>
        </div>
    );
}

export default Main;
